// extracted by mini-css-extract-plugin
export default {"main":"main__4CGn6","content":"content__jyeTu","head":"head__Aade6","form-controller":"form-controller__Xm82Q","image":"image__Qw2+p"};